/*
 * Project: bellcloud
 * File: packages/ui/components/common/Feedback.tsx
 * Description: 피드백 컴포넌트 (Spinner)
 */

import styled from '@emotion/styled';

// 로딩 스피너
export const Spinner = styled.div<{ size?: 'sm' | 'md' | 'lg' }>`
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  ${({ size = 'md' }) => {
    const sizes: Record<string, string> = { sm: '16px', md: '24px', lg: '32px' };
    return `width: ${sizes[size]}; height: ${sizes[size]};`;
  }}
`;
